import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'projects/kesher-site/src/environments/environment';
import { AdvMessageService, FormValidationsService, LocalizationService, OwnValidators, ValidatorService } from 'shared/src/public-api';
import { AppAuthService } from '../../../kesher-shared/services/app-auth.service';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  constructor(private _appAuthService: AppAuthService,
    private formValidationsService: FormValidationsService,
    private messagesService: AdvMessageService,
    private _localizationService: LocalizationService,
    private passwordValidatorService: ValidatorService) { }

  changePasswordForm: FormGroup;

  @Output() login: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.initForm();
  }

  changePassword() {
    if (this.changePasswordForm.valid) {
      let changePassModel = this.changePasswordForm.value;
      if (changePassModel)
        changePassModel.clientVersion = environment.version;
      this._appAuthService.changePassword(this.changePasswordForm.value).subscribe((res: any) => {
        if (res.succeeded) {
          this.messagesService.successMessage(this._localizationService.Translate("LOGIN.MESSAGES.CHANGE_PASSWORD_SUCCEEDED"));
          this.login.emit(this.changePasswordForm.get("Password").value);
        }
      });
    }
    else {
      this.formValidationsService.markFormGroupTouched(this.changePasswordForm);
    }
  }

  private initForm() {
    this.changePasswordForm = new FormGroup({
      Password: new FormControl('', [Validators.required, OwnValidators.correctPassword], [(control: FormControl) => this.passwordValidatorService.asyncCheckIfPasswordWeak(control)]),
      PasswordConfirm: new FormControl('', [Validators.required, this.confirmPasswordMatch.bind(this)])
    });
  }

  private confirmPasswordMatch(control: FormControl) {
    return control.value == this.changePasswordForm?.get("Password")?.value ? null : { passwordMismatch: true };
  }

  onPasswordChanged() {
    this.changePasswordForm.controls.PasswordConfirm.updateValueAndValidity();
  }

}
